import React,{useEffect,useContext} from 'react'
import LoginComponent from '../../components/LoginComponents/LoginComponent';
import { useNavigate, useLocation } from "react-router-dom";
import { ApiContext } from '../../context/MyContext';



function LoginPage() {
  const {isAuthenticated } = useContext(ApiContext);
  const navigate = useNavigate();
  const location = useLocation();

  // Store the redirect path from location state into localStorage
  useEffect(() => {
    if (location.state?.from) {
      localStorage.setItem('redirectAfterLogin', location.state.from);
    }
  }, [location.state]);

  useEffect(() => {
    if (isAuthenticated) {
      // Check if there's a redirect path stored
      const redirectPath = localStorage.getItem('redirectAfterLogin') || '/home';
      localStorage.removeItem('redirectAfterLogin'); // Clear it
      navigate(redirectPath);
    } else {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="w-screen h-screen flex items-center justify-center">
       <LoginComponent/>
    </div>
  )
}

export default LoginPage